import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import React from "react";
import SearchField from "../../Form/SearchField";
import { StageSearch } from "./StageSearch";
import HiddenField from "../../Form/HiddenField";
const CHANGE_STAGE_GET_CRITERIA = (formState, additionalInfo) => ({
    pipelineId: { value: formState.stage.pipeline.id, isReference: false },
    personId: {
        isReference: true,
        propertyName: "personId",
        workflowNodeReferenceId: formState.personLoaderId,
    },
});
export const getChangeStageRequest = (formState) => {
    return {
        stage: formState.stage,
    };
};
const ChangeStageForm = ({ pipelineId }) => {
    return (_jsxs(_Fragment, { children: [_jsx(HiddenField, { name: "personLoaderId" }), _jsx(SearchField, { name: "stage", label: "Stage", required: true, as: (provided) => (_jsx(StageSearch, Object.assign({ lookupModal: { isInModal: true }, 
                    // @ts-expect-error - TS2322 - Type 'number | null | undefined' is not assignable to type 'number'.
                    pipelineIds: [pipelineId] }, provided))) })] }));
};
export default ChangeStageForm;
